import { render, staticRenderFns } from "./WheelsetPage.vue?vue&type=template&id=648f3eee&"
import script from "./WheelsetPage.vue?vue&type=script&lang=js&"
export * from "./WheelsetPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports